import React from 'react'

type Props = {
    onSubmit?: () => void
    children: React.ReactNode
    className?: string
    autoComplete?: 'on' | 'off'
}

const Form = ({ children, onSubmit, className, autoComplete }: Props) => {
    return (
        <form
            autoComplete={autoComplete}
            className={className}
            onSubmit={(e) => {
                e.preventDefault()
                onSubmit && onSubmit()
            }}
        >
            {children}
        </form>
    )
}

export default Form
